import React, { useEffect } from 'react';
import '../../assets/styles/blogModal.scss';

export type BlogModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  date: string;
  image: string;
  content: string;
  videoUrl?: string;
};

const BlogModal: React.FC<BlogModalProps> = ({
  isOpen,
  onClose,
  title,
  date,
  image,
  content,
  videoUrl,
}) => {
  // ESC tuşu ile kapatma
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="blog-modal-overlay" onClick={onClose}>
      <div className="blog-modal" onClick={(e) => e.stopPropagation()}>
        <button className="blog-modal-close" onClick={onClose} aria-label="Kapat">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <div className="blog-modal-content">
          <div className="blog-modal-image">
            <img src={image} alt={title} />
          </div>

          <div className="blog-modal-body">
            <time className="blog-modal-date">{date}</time>
            <h2 className="blog-modal-title">{title}</h2>
            
            {videoUrl && (
              <div className="blog-modal-video">
                <iframe
                  src={videoUrl}
                  title={title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            )}

            <div className="blog-modal-text">
              {content.split('\n').map((paragraph, index) => {
                if (!paragraph.trim()) return null;
                
                const trimmed = paragraph.trim();
                
                // Başlık mı kontrol et
                // Liste öğelerini hariç tut (küçük harfle başlayan veya "da/de/ise" içeren)
                const startsWithLowercase = /^[a-zçğıöşü]/.test(trimmed);
                const containsListWords = /\b(da|de|ise|durumunda|durumlarında|arasında|yanı sıra)\b/i.test(trimmed);
                
                const isHeading = !startsWithLowercase && 
                                 !containsListWords &&
                                 (trimmed.endsWith('?') || 
                                  trimmed.endsWith(':') || 
                                  (trimmed.length < 80 && !trimmed.includes('.')));
                
                return isHeading ? (
                  <h3 key={index} className="blog-modal-heading">{paragraph}</h3>
                ) : (
                  <p key={index}>{paragraph}</p>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogModal;
